var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCountryFlagUksvgrIcon = function SvgCountryFlagUksvgrIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#country-flag-uk_svgrIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M3.308 6.259A15.9 15.9 0 0 0 .55 11.826h8.324zM31.449 11.826a15.9 15.9 0 0 0-2.756-5.567l-5.568 5.567zM.551 20.174a15.9 15.9 0 0 0 2.757 5.567l5.567-5.567zM25.741 3.307A15.9 15.9 0 0 0 20.174.551v8.323zM6.259 28.692a15.9 15.9 0 0 0 5.567 2.756v-8.323zM11.826.55A15.9 15.9 0 0 0 6.26 3.308l5.567 5.567zM20.174 31.449a15.95 15.95 0 0 0 5.567-2.757l-5.567-5.567zM23.125 20.174l5.568 5.567a15.9 15.9 0 0 0 2.756-5.567z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M31.865 13.913H18.087V.135a16.2 16.2 0 0 0-4.174 0v13.778H.135a16.2 16.2 0 0 0 0 4.174h13.778v13.778a16.2 16.2 0 0 0 4.174 0V18.087h13.778a16.2 16.2 0 0 0 0-4.174"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "m20.174 20.174 7.14 7.14q.492-.494.94-1.027l-6.112-6.113zM11.826 20.174l-7.14 7.14q.494.492 1.027.94l6.113-6.113zM11.826 11.827l-7.14-7.14q-.492.492-.94 1.027l6.113 6.112zM20.174 11.826l7.14-7.14a16 16 0 0 0-1.027-.94L20.174 9.86z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    x: 1,
    y: 1,
    stroke: "currentColor",
    strokeWidth: 2,
    rx: 15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "country-flag-uk_svgrIcon_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff",
    rx: 16
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCountryFlagUksvgrIcon);
export default ForwardRef;